import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import UploadCampaign from '../../../Components/UploadCampaign';
import DropFileTable from '../../../Components/DropFileTable';
import VersionDetails from '../../../Components/VersionDetails';
import { useDispatch, useSelector } from 'react-redux';
import { toggleNameYourTemplateModal, toggleSelectTemplateModal } from '../../../../../../slices/modals/reducer';
import SelectTemplateModal from './SelectTemplateModal';
import { createTemplate, createVersion, createVersionHtmlTemplate, getTemplate, getTemplateCategory, openCampaign } from '../../../../../../slices/campaigns/thunk';
import { createSelector } from 'reselect';
import SelectedTemplatePage from './SelectedTemplatePage';
import { setCampaignLoader, setSelectedTemplate, setTemplateCategories, setTemplateLoader } from '../../../../../../slices/campaigns/reducer';
import SelectFromTemplate from './SelectFromTemplate';
import NameYourTemplate from './NameYourTemplate';
import { setPreloader } from '../../../../../../slices/layouts/reducer';
import { useProfile } from '../../../../../../Components/Hooks/UserHooks';
import { setUploadedFiles } from '../../../../../../slices/uploads/reducer';
import { setBreadcrumb } from '../../../../../../slices/auth/menu/reducer';
import { toast } from 'react-toastify';

function EmptyPage() {
  const dispatch = useDispatch();
  const selectTemplateState = createSelector(state => state, state => ({
    selectedTemplate: state.Campaign.selectedTemplate,
    uploadedFiles: state.Upload.uploadedFiles,
    uploadLimits: state.Upload.uploadLimits,
    currentCampaign: state.Campaign.currentCampaign
  }));
  const { selectedTemplate, uploadedFiles, uploadLimits, currentCampaign } = useSelector(selectTemplateState);
  const [isSubmit, setIsSubmit] = useState(false);

  function handleSubmit() {
    setIsSubmit(true);
  }

  async function submitFunc(values, resetForm) {
    if (selectedTemplate === null) {
      toast.error('Please select template', {autoClose: 3000});
      return;
    } 
    dispatch(setCampaignLoader(true));
    await dispatch(createVersionHtmlTemplate(values));
    dispatch(setBreadcrumb({ pageTitle: 'Ad Library', title: [] }));
    await dispatch(openCampaign(currentCampaign));
    resetForm();
  }

  function returnEmptyPage() {
    dispatch(setUploadedFiles([]));
    dispatch(setSelectedTemplate(null))
  }

  async function changeTemplate() {
    dispatch(setTemplateCategories([]));
    dispatch(toggleSelectTemplateModal());
    dispatch(setTemplateLoader(true));
    await dispatch(getTemplate());
    await dispatch(getTemplateCategory());
    dispatch(setTemplateLoader(false));
  }

  const { token, userId } = useProfile();
  function editAllInFigmaPlugin() {
    dispatch(toggleFigmaPluginModal());
    setTimeout(() => {
      const iframe = createFigmaPlugin();
      iframe.onload = async () => {
        iframe.contentWindow.postMessage({
          action: 'adc-login-control',
          token: token,
          userid: userId,
        }, '*');
        iframe.contentWindow.postMessage({
          action: 'adc-show-frames',
          frames: uploadedFiles.map(item => item.figmaObject.node),
          tempThumb: '',
          isPlatform: true,
          creativeCreated: false
        }, '*');
        window.addEventListener('message', function (event) {
          if (event?.data) {
            if (event.data.pluginMessage) {
              return;
            }
            if (event.data.action === 'adc-template-creative-edit') {
              const templateCreatives = [];
              const frames = JSON.parse(event.data.frames);
              let i = 0;
              do {
                const file = uploadedFiles[i];
                templateCreatives.push({ ...file, figmaObject: frames[i].figma });
                i++;
              } while (i < uploadedFiles.length);
              dispatch(setUploadedFiles(templateCreatives));
              dispatch(toggleFigmaPluginModal());
            }
          }
        })
      }
    }, 500);
  };
  return (
    <React.Fragment>
      <Row>
        {selectedTemplate !== null ?
          <Col xxl={12} sm={12}>
            <Card className='d-flex flex-row p-3 align-items-center'>
              <button className='btn btn-icon btn-light fw-bold me-2' onClick={returnEmptyPage}>
                <i className='ri-arrow-left-line'></i>
              </button>
              <p className='m-0'>{selectedTemplate.name}</p>
              <div className='d-flex ms-auto me-0'>
                {/* <button className='btn btn-light me-1' onClick={editAllInFigmaPlugin}>
      <i className='mdi mdi-square-edit-outline align-bottom me-1'></i>
      Edit All Creatives In Figma Plugin
    </button> */}
                <button className='btn btn-soft-primary' onClick={changeTemplate}>Change Template</button>
              </div>
            </Card>
          </Col>
          : null}
      </Row>
      <Row className='flex-column-reverse flex-xxl-row'>
        {selectedTemplate !== null ?
          <React.Fragment>
            <Col xxl={8} md={12}>
              <SelectedTemplatePage />
            </Col>
          </React.Fragment>
          :
          <React.Fragment>
            {uploadedFiles?.length === 0 ?
              <Col xxl={4}>
                <SelectFromTemplate />
              </Col>
              : null}
          </React.Fragment>
        }
        <Col xxl={4} md={12}>
          <Card style={{ minHeight: "330px" }}>
            <CardHeader>Version Details</CardHeader>
            <CardBody>
              <VersionDetails isSubmit={isSubmit} submitFunc={async (values, resetForm) => await submitFunc(values, resetForm)} />
              {uploadedFiles?.length > 0 ?
                <div className='w-100 d-flex justify-content-end gap-1'>
                  <button className='btn btn-success mt-3 ms-auto me-0' onClick={handleSubmit}>
                    {selectedTemplate !== null ? "Create Set" : "Add Version"}
                  </button>
                </div>
                : null}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <SelectTemplateModal />
    </React.Fragment>
  )
}

export default EmptyPage
